export const INTRO_CONTENT = {
  welcome: 'WELCOME TO THE VIRTUAL EXPERIENCE',
  boothName: '',
  loadingMessage: 'LOADING, PLEASE WAIT',
}
